import React, { useState } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import "../../css/main.css";
import { getProfile, getUploadAvatar } from "../../redux/action";

function UploadAvatar() {
  const [Pic, setPic] = useState(null);
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.UploadAvatar);
  const req = () => {
    if (Pic) {
      dispatch(getUploadAvatar(Pic));
      dispatch(getProfile());
      if (data) {
        // localStorage.setItem("User", JSON.stringify(data.user));
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Profile picture changed successfully",
          showConfirmButton: false,
          timer: 1000,
        });
        setTimeout(() => {
          dispatch(getProfile());
        }, 1000);
      } else if (error) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } else {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Select your file",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  return (
    <div className="w-full">
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="sm:flex -ml-96 w-80 sm:w-96 sm:-ml-56 md:w-80 md:-ml-12 lg:w-10/12 lg:ml-5 xl:w-7/12 xl:ml-32 2xl:w-4/12 2xl:ml-96">
          <div className="card w-full bg-primary text-primary-content mt-72 sm:mt-32 shadow-lg">
            <div className="card-body text-black dark:text-slate-100">
              <form onSubmit={(e) => e.preventDefault()}>
                <div
                  className="tooltip"
                  data-tip="The corresponding image must be under 2 MB and only have extensions (PNG, JPG)"
                >
                  <input
                    type="file"
                    accept=".jpg, .png"
                    className="file-input file-input-bordered file-input-accent
                w-full"
                    onChange={(e) => setPic(e.target.files[0])}
                  />
                </div>
                <div className="card-actions justify-evenly mt-5">
                  <button className="btn sm:w-5/12 lg:w-4/12" onClick={req}>
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UploadAvatar;
